import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'

export default function RefreshEmploymentsOnPipe () {
  return (
    <>
      <ExecuteOperationOnPipe namespace='api' resourceName='employments.employment' operationName='index' />
    </>
  )
}
